/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/dimensions" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdDimensions } from "./constants";
import type { GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsResult } from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdDimensions = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdDimensions,
  (
    signal: AbortSignal,
    appGroupId: string,
    dsaId: string
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/dimensions`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsResult
);
